export const PADDING = 15;
export const FONT_SIZE = 11;
export const FOOTER_HEIGHT = 12;
export const LINE_PADDING = 3;
export const BULLET_POINT = '\u2022';
